import { useState } from 'react'
import { Flex, Text } from '@radix-ui/themes'
import { EyeOpenIcon, EyeClosedIcon } from '@radix-ui/react-icons'
import { formatValue } from './claim-form-utils'
import { FieldRow } from './claim-form-fields'
import { CLAIMANT_ROWS, getFieldLabel } from './claim-form-constants'

function maskSSN(ssn: string): string {
  if (ssn.length <= 4) {
    return ssn
  }
  return '***-**-' + ssn.slice(-4)
}

function SSNField({ value }: { value: string | null }) {
  const [visible, setVisible] = useState(false)

  if (!value) {
    return null
  }

  return (
    <Flex direction="column" gap="1" className="claim-form-field">
      <Text size="1" color="gray">
        SSN
      </Text>
      <Flex align="center" gap="2">
        <Text size="2">{visible ? value : maskSSN(value)}</Text>
        <button
          className="claim-form-ssn-toggle"
          onClick={() => setVisible((prev) => !prev)}
          aria-label={visible ? 'Hide SSN' : 'Show SSN'}>
          {visible ? <EyeOpenIcon /> : <EyeClosedIcon />}
        </button>
      </Flex>
    </Flex>
  )
}

export function ClaimantFields({ data }: { data: Record<string, unknown> }) {
  return (
    <Flex direction="column" gap="3">
      {CLAIMANT_ROWS.map(([left, right]) => (
        <div key={left} className="claim-form-two-col">
          {left === 'socialSecurityNumber' ? (
            <SSNField value={formatValue(data[left])} />
          ) : (
            <FieldRow label={getFieldLabel(left)} value={formatValue(data[left])} />
          )}
          {right ? (
            <FieldRow label={getFieldLabel(right)} value={formatValue(data[right])} />
          ) : (
            <div />
          )}
        </div>
      ))}
    </Flex>
  )
}
